export default __webpack_public_path__ + "static/P2P_Cam_Live_01-a718576e91c2ff2021e8205b16dc43f8.webp";